module.exports = __webpack_public_path__ + "static/yahoo_calendar_2-060e0e1fb8d3d4a286e74fa6d7fb5aef.png";